export default __webpack_public_path__ + "static/media/585.ac559f34.gif";